import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import DatePicker from 'react-datepicker';
import Headers from '../Header';
import NavigationBar from '../Navigation';
import Loader from '../../common/Loader';
import NoAppointmentsFound from '../../common/NoDataFound';
import SessionType from './../../common/SessionType';
import { Pagination } from './../../common/Pagination';
import SessionStatusButton from './../../common/SessionStatusButton';
import { getStudentSessionList, getAllSessions } from './../../../action/student/AppointmentAction';
import { PATH } from '../../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
// import profileImg from "../../../../utils/images/profileImg.png";
import { paginationCount } from '../../../../utils/URL';
import { connectVideoCall } from '../../../action/SocketActions';
import { getVisitInformation } from '../../../action/student/WaitingRoomAction';
import {
    BroadCastSession,
    ClassroomSession,
    Good,
    OnDemand,
    Scheduled,
    Student,
} from '../../../../utils/common/NamingTerms';
import CheckNetworkConnection from '../../common/CheckNetworkConnection';
import CheckMediaAccess from '../../common/CheckMediaAccess';
import store from '../../../../sessionStorage';
import { myLog } from '../../../../utils/Utility';
import AppConfig from '../../../../utils/common/DomainConfiguration';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

const { detect } = require('detect-browser');
const browser = detect();

/**
 * @package VirtOwl
 * @type {React.ComponentClass}
 */
let today = new Date();
let strDate = moment(today).format('YYYY-MM-DD HH:mm:ss');

class StudentSessionList extends Component {
    static propTypes = {
        getStudentSessionList: PropTypes.func,
        match: PropTypes.any,
        getAllSessions: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            isLoading: false,
            strDate,
            type: 'all',
            time: '',
            currentPage: 0,
            todosPerPage: paginationCount,
            totalPages: 0,
            offSetValue: 0,
            date: new Date(),
            customSelect: false,
            userId: '',
            noSession: false,
            sessionList: [],
            sessionId: 0,
        };
        this.networkChecker = new CheckNetworkConnection();
        this.mediaChecker = new CheckMediaAccess();
        this.networkChecker.browser = browser.name;
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleChangeFilterSortBy = this.handleChangeFilterSortBy.bind(this);
        this.handleChangeFilterCustomDate = this.handleChangeFilterCustomDate.bind(this);
    }

    /**
     * @inheritDoc
     */
    componentWillMount() {
        this.invokeAppointmentList(
            this.state.type,
            '',
            this.state.currentPage,
            this.state.todosPerPage
        );
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({ time: Date.now() });
            this.invokeAppointmentList(
                this.state.type,
                this.state.type === 'custom' ? this.state.strDate : '',
                this.state.currentPage,
                this.state.todosPerPage
            );
        }, 60000);
    }

    /**
     * @inheritDoc
     */
    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.interval);
    }

    /**
     * Invoke Appointment List
     * @param {Number} type
     * @param {Date} strDate
     * @param {Number} pagenumber
     * @param {Number} pagePerCount
     */
    invokeAppointmentList(type, strDate, pagenumber, pagePerCount) {
        this.isLoading();
        this.props.getStudentSessionList(
            type,
            strDate,
            (pagenumber = pagenumber + 1),
            pagePerCount,
            (response) => {
                this.isLoading();
                if (response) {
                    if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            totalPages: 0,
                            noSession: true,
                            sessionList: [],
                        });
                    } else {
                        this.setState({
                            currentPage: response.response.pageNumber,
                            noSession: false,
                            totalPages: response.response.totalPages,
                            sessionList: response.response.data,
                        });
                    }
                }
            }
        );
    }

    getAllSessions(type, strDate, pagenumber, itemsPerPage) {
        this.isLoading();
        this.props.getAllSessions(
            type,
            strDate,
            (pagenumber = pagenumber + 1),
            itemsPerPage,
            (response) => {
                this.isLoading();
                if (response) {
                    if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            totalPages: 0,
                            noSession: true,
                            sessionList: [],
                        });
                    } else {
                        this.setState({
                            currentPage: response.response.pageNumber,
                            noSession: false,
                            totalPages: response.response.totalPages,
                            sessionList: response.response.data,
                        });
                    }
                }
            }
        );
    }

    // Handle  Filter  SortBy
    handleChangeFilterSortBy = (e) => {
        let type = e.target.value;
        if (type === 'custom') {
            this.setState({ customSelect: true, date: null });
        } else {
            this.setState({ customSelect: false, type }, () => {
                this.invokeAppointmentList(
                    type,
                    '',
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            });
        }
    };

    // Handle  Filter  custom
    handleChangeFilterCustomDate = (day) => {
        let strDate = moment(day).format('YYYY-MM-DD');
        this.setState(
            {
                type: 'custom',
                strDate,
                date: day,
            },
            () => {
                this.invokeAppointmentList(
                    this.state.type,
                    this.state.strDate,
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            }
        );
    };

    // Handle  Page change
    handlePageChange(event) {
        const newPage = Number(event.selected);
        this.setState(
            {
                currentPage: newPage,
                offSetValue: newPage * this.state.todosPerPage,
            },
            () => {
                this.invokeAppointmentList(
                    this.state.type,
                    this.state.strDate,
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            }
        );
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // Handle toggle loader
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    preCallTest = async (type, visitId) => {
        try {
            this.setState({ checkPermissionStatus: true });
            await this.mediaChecker.finalCheckingPermission();
            if (
                this.mediaChecker.state.cameraGranted &&
                this.mediaChecker.state.microphoneGranted &&
                !this.mediaChecker.state.systemCameraBlocked &&
                !this.mediaChecker.state.systemMicrophoneBlocked
            ) {
                const networkGood =
                    this.networkChecker.browser === 'firefox' ||
                    this.networkChecker.browser === 'safari'
                        ? await this.networkChecker.checkfirefoxNetworkSignal()
                        : await this.networkChecker.checkNetworkSignal();

                if (networkGood && this.networkChecker.state.networkQuality === Good) {
                    this.handleVideoCall(type, visitId);
                }
            } else {
                this.setState({ checkPermissionStatus: false });
            }
        } catch (error) {
            console.log('error: ', error);
        }
    };

    navigateToDetailScreen = (type, visitId) => {
        if (type === 'waitingRoom') {
            this.props.history.push(
                `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${visitId}`
            );
        } else {
            this.preCallTest(type, visitId);
        }
    };

    invokeVisitInfo(visitId, initialCall) {
        this.isLoading();
        this.props.getVisitInformation(visitId, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                let optionDetails = [];
                if (response.response.sessionUsers && response.response.sessionUsers.length) {
                    response.response.sessionUsers.forEach((element) => {
                        let obj = {
                            label: element.name,
                            value: element.id,
                        };
                        optionDetails.push(obj);
                    });
                }
                this.setState(
                    {
                        visitInfo: response.response,
                        sessionStatus: response.response.sessionStatus,
                        isTabName:
                            response.response.sessionStatus === 'Note Pending' ? 'chat' : 'notes',
                        patientEmail: response.response.tutor?.email,
                        patientName: response.response.tutor?.name,
                        sessionStudents: response.response.sessionUsers,
                        uploadedImages: response.response.soapNote?.visitComplaintImages,
                        visitType: response.response.visitType,
                        materialUploadedImages: response.response.soapNote?.materialImages,
                        broadcast: response.response.activeSession?.broadcast,
                    },
                    () => {
                        if (
                            this.state.broadcast &&
                            this.state.broadcast?.hls &&
                            response.response.visitType === BroadCastSession
                        ) {
                            store.set('broadcastUrl', this.state.broadcast?.hls);
                        } else {
                            store.set('broadcastUrl', '');
                        }
                        if (
                            this.state.sessionStatus === 'Missed' ||
                            this.state.sessionStatus === 'Cancelled' ||
                            this.state.sessionStatus === 'Note Pending' ||
                            this.state.sessionStatus === 'Completed'
                        ) {
                            clearInterval(this.timer);
                        }
                        if (response.response.sessionStatus === 'Note Pending') {
                            this.setState({ chatLoading: true });
                            this.getSessionSummaryChatWithPagination(
                                this.state.visitInfo.id,
                                0,
                                this.state.chatPerPage
                            );
                        }
                        if (
                            response.response.visitType !== ClassroomSession &&
                            response.response.visitType !== BroadCastSession
                        ) {
                            this.setState({
                                patientUserId: response.response.tutee.userId
                                    ? response.response.tutee.userId
                                    : 0,
                            });
                            if (initialCall || this.state.visitType === OnDemand) {
                                if (response.response && response.response.isOnDemand) {
                                    if (response.response && response.response.visitStatus === 1) {
                                        if (
                                            response.response &&
                                            response.response.userCategory === 1 &&
                                            response.response.physicianAppointmentType === 0
                                        ) {
                                            this.setState({
                                                sessionStatus: 'Enter Virtual Class Room',
                                            });
                                        } else {
                                            this.setState({
                                                sessionStatus: Scheduled,
                                            });
                                        }
                                    }
                                    this.setState({ countDown: '0:00:00' });
                                }
                                if (this.state.visitInfo && this.state.visitInfo.isAppointment) {
                                    this.interval = setInterval(() => {
                                        this.setState({ time: Date.now() });
                                        let d1 = moment(
                                            this.state.visitInfo.appointment?.startTime
                                        );
                                        let d2 = moment(this.state.time);
                                        let ms = moment(d1, 'YYYYMMDD HH:mm:ss').diff(
                                            moment(d2, 'YYYYMMDD HH:mm:ss')
                                        );
                                        let d = moment.duration(ms);
                                        let ans =
                                            Math.floor(d.asHours()) +
                                            moment.utc(ms).format(':mm:ss');

                                        let end = moment(this.state.visitInfo.appointment?.endTime);

                                        if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                moment(d1, 'YYYYMMDD HH:mm:ss').subtract(
                                                    10,
                                                    'minute'
                                                )
                                            ) &&
                                            moment(d2, 'YYYYDDMM HH:mm:ss').isBefore(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                moment(d1, 'YYYYMMDD HH:mm:ss')
                                            )
                                        ) {
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            ) &&
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                end,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            clearInterval(this.interval);
                                            this.setState({ countDown: '0:00:00' });
                                        } else {
                                            this.setState({ countDown: '0:00:00' });
                                        }
                                    }, 1000);
                                }
                            }
                        }
                    }
                );
                this.isLoading();
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
            }
        });
    }

    handleVideoCall = (type, visitId) => {
        sessionStorage.setItem('VISIT_TYPE', type);
        this.setState({ isLoading: true });

        const { connectVideoCall, visitInformation } = this.props;

        this.props.getVisitInformation(visitId, (res) => {
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ isLoading: false });

                const userId = store.get('userSession').id;

                let path = `${PATH.IM_PATIENT.VIDEO_CALL}/${visitId}/${Student}/${userId}`;
                if (type === 'class_room') path += '/classroom';
                else if (type === 'broadcast') path += '/broadcast';

                connectVideoCall(
                    type === 'class_room' || type === 'broadcast'
                        ? res.response
                        : res.response.activeSession
                );
                this.props.history.push(path);
            } else {
                connectVideoCall(visitInformation?.activeVisitSession);
            }
        });
    };

    // renders Row Data
    renderStudentSessionList() {
        return (
            <>
                {this.state.noSession || !this.state.sessionList.length ? (
                    <NoAppointmentsFound isFrom={'Session'} />
                ) : (
                    <>
                        {this.state.sessionList.map((session, index) => (
                            <div className="h-auto p-4 rounded-lg bg-card" key={index}>
                                <div className="justify-between sm:flex gap-x-6">
                                    <div className="items-center mb-5 sm:flex gap-x-4 sm:mb-0">
                                        {/* <img
                      className="w-12 h-12 mx-auto mb-5 rounded-full lg:w-20 lg:h-20 bg-gray-50 lg:mb-0"
                      src={session.educatorPhoto ?? profileImg}
                      alt=""
                    /> */}
                                        <div className="flex-auto min-w-0 lg:w-48">
                                            <div className="items-center mb-1 sm:flex">
                                                <div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {this.props.t('ownerName')}
                                                        </p>
                                                        <p
                                                            className="mb-0 text-base font-normal leading-6 truncate text-UIsecondary"
                                                            title={session.educatorName}
                                                        >
                                                            {session.educatorName}
                                                        </p>
                                                    </div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48 sm:mb-0">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {this.props.t('createdBy')}
                                                        </p>
                                                        <p
                                                            className="mb-0 font-normal leading-6 truncate text-UIsecondary"
                                                            title={session.createdBy}
                                                        >
                                                            {session.createdBy}
                                                        </p>
                                                    </div>
                                                </div>
                                                <span
                                                    className="hidden w-px h-24 xxl:ml-12 xxl:mr-12 md:ml-6 md:mr-6 line-bg sm:block"
                                                    aria-hidden="true"
                                                ></span>
                                                <div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {AppConfig.labels.channelName}
                                                        </p>
                                                        <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                            {session?.subject
                                                                ? session.subject
                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                        </p>
                                                    </div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48 sm:mb-0">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {this.props.t('element')}
                                                        </p>
                                                        <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                            {session.subCategory
                                                                ? session.subCategory
                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                        </p>
                                                    </div>
                                                </div>
                                                <span
                                                    className="hidden w-px h-24 xxl:ml-12 xxl:mr-12 md:ml-6 md:mr-6 line-bg sm:block"
                                                    aria-hidden="true"
                                                ></span>
                                                <div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {this.props.t('dateAndTime')}
                                                        </p>
                                                        <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                            {moment(session.sessionStartDate)
                                                                .locale(
                                                                    AppConfig.appLanguage || 'en'
                                                                )
                                                                .format('MMM DD, YYYY hh:mm A')}
                                                        </p>
                                                    </div>
                                                    <div className="flex-auto min-w-0 mb-3 lg:w-48 sm:mb-0">
                                                        <p className="mb-1 text-sm leading-5 text-white truncate">
                                                            {this.props.t('sessionType')}
                                                        </p>
                                                        <SessionType
                                                            sessionType={session.sessionType}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col justify-center sm:items-end">
                                        <SessionStatusButton
                                            joinText={this.props.t('join')}
                                            status={session.sessionStatus}
                                            visitId={session.sessionId}
                                            sessionType={session.sessionType}
                                            isStudentSessionList={true}
                                            navigateToDetailScreen={(type, visitId) =>
                                                this.navigateToDetailScreen(type, visitId)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </>
        );
    }

    /**
     * Handle toggle modal
     * @param {String} pictureUrl
     */
    render() {
        let pageDisplayCount = this.state.totalPages;
        return (
            <div className="fixed top-0 left-0 flex w-full h-full bg-UIBackground">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PATIENT.APPOINTMENT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={this.props.t('sessions')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-4xl font-medium text-white">
                                {this.props.t('sessions')}
                            </h6>
                            <div
                                className={`sm:flex gap-4 sm:mt-0 mt-4 ${
                                    this.state.customSelect ? 'lg:w-2/8' : 'lg:w-2/6'
                                }`}
                            >
                                <div className="relative w-full">
                                    <select
                                        id="countries"
                                        className="w-full bg-[#23262D] text-white font-normal rounded block py-1.5 px-2 pr-10 
               appearance-none text-UIprimary cursor-pointer"
                                        style={{ cursor: 'pointer' }}
                                        onChange={this.handleChangeFilterSortBy}
                                    >
                                        <option value="all session" className="text-white">
                                            {this.props.t('allSessions')}
                                        </option>
                                        <option value="today" className="text-white">
                                            {this.props.t('todaySession')}
                                        </option>
                                        <option value="previous" className="text-white">
                                            {this.props.t('previousSession')}
                                        </option>
                                        <option value="future" className="text-white">
                                            {this.props.t('upcomingSessions')}
                                        </option>
                                        <option value="custom" className="text-white">
                                            {this.props.t('customDate')}
                                        </option>
                                    </select>
                                    <div className="absolute inset-y-0 flex items-center pointer-events-none right-3">
                                        <svg
                                            className="w-4 h-4 text-UIprimary"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                {this.state.customSelect ? (
                                    <div className="relative flex-wrap items-stretch w-full mb-0 sm:flex">
                                        <div className="flex w-full mt-2 mb-0 rounded bg-[#23262D] sm:mt-0">
                                            <div className="grow">
                                                <DatePicker
                                                    name="date"
                                                    className="w-full px-2 py-1 text-base leading-normal text-white placeholder:text-secondary example-custom-input"
                                                    placeholderText={this.props.t('selectAnyDate')}
                                                    selected={
                                                        (this.state.date &&
                                                            new Date(this.state.date)) ||
                                                        null
                                                    }
                                                    value={this.state.date}
                                                    onChange={(event) => {
                                                        this.handleChangeFilterCustomDate(event);
                                                        this.setState({
                                                            date: event,
                                                        });
                                                    }}
                                                    dropdownMode="select"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={80}
                                                    scrollableYearDropdown
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <button
                                    className="bg-UIprimary p-3 py-1.5 rounded-lg text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4"
                                    onClick={() =>
                                        this.props.history.push(
                                            `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}/create`
                                        )
                                    }
                                >
                                    {this.props.t('createSession')}
                                </button>
                            </div>
                        </div>
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                                {this.renderStudentSessionList()}
                                <div className="text-right">
                                    {pageDisplayCount > 1 && (
                                        <Pagination
                                            currentPage={this.state.currentPage}
                                            pageDisplayCount={pageDisplayCount}
                                            onPageChange={this.handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getStudentSessionList: (type, strDate, pageNumber, itemsPerPage, callBack) => {
            dispatch(getStudentSessionList(type, strDate, pageNumber, itemsPerPage, callBack));
        },

        getAllSessions: (type, strDate, pageNumber, itemsPerPage, callBack) => {
            dispatch(getAllSessions(type, strDate, pageNumber, itemsPerPage, callBack));
        },
        connectVideoCall: (data) => {
            dispatch(connectVideoCall(data));
        },
        getVisitInformation: (visitId, callBack) => {
            dispatch(getVisitInformation(visitId, callBack));
        },
    };
};

const ConnectedStudentSessionList = withLanguage(
    connect(null, mapDispatchToProps)(StudentSessionList)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedStudentSessionList {...props} />
    </LanguageProvider>
);
